import React from "react";
import Inview from "./inview";

require("../../sass/components/nounproject-customblock-diversity.sass");

class DiversityCustomBlock extends React.Component {
    static defaultProps = {
        diverseTermList: [
            {
                extra_terms: [
                    { term: "noodle" },
                    { term: "geometry" },
                    { term: "dance" },
                    { term: "ant eater" },
                    { term: "chemistry" },
                    { term: "earthquake" },
                    { term: "water bottle" },
                    { term: "lava" },
                    { term: "giraffe" },
                    { term: "quantum physics" }
                ],
                term: "giraffe",
                icons: [
                    {
                        icon_id: "952516",
                        sprite: "#np_camel_952516_000000.svg"
                    },
                    {
                        icon_id: "230987",
                        sprite: "#np_giraffe_230987_000000.svg"
                    },
                    {
                        icon_id: "394572",
                        sprite: "#np_giraffe_394572_000000.svg"
                    },
                    {
                        icon_id: "683809",
                        sprite: "#np_giraffe_683809_000000.svg"
                    },
                    {
                        icon_id: "699951",
                        sprite: "#np_giraffe_699951_000000.svg"
                    },
                    {
                        icon_id: "954090",
                        sprite: "#np_giraffe_954090_000000.svg"
                    }
                ]
            },
            {
                extra_terms: [
                    { term: "lava" },
                    { term: "giraffe" },
                    { term: "quantum physics" },
                    { term: "space" },
                    { term: "fake news" },
                    { term: "sprout" },
                    { term: "jenga" },
                    { term: "supernova" },
                    { term: "activist" },
                    { term: "whiskey" }
                ],
                term: "activist",
                icons: [
                    {
                        icon_id: "856569",
                        sprite: "#np_green-adviser_856569_000000.svg"
                    },
                    {
                        icon_id: "37850",
                        sprite: "#np_hunger-strike_37850_000000.svg"
                    },
                    {
                        icon_id: "854369",
                        sprite: "#np_manifestation_854369_000000.svg"
                    },
                    {
                        icon_id: "760",
                        sprite: "#np_peaceful-protest_760_000000.svg"
                    },
                    {
                        icon_id: "919787",
                        sprite: "#np_protestor_919787_000000.svg"
                    },
                    {
                        icon_id: "922326",
                        sprite: "#np_supporter_922326_000000.svg"
                    }
                ]
            },
            {
                extra_terms: [
                    { term: "supernova" },
                    { term: "activist" },
                    { term: "whiskey" },
                    { term: "gymnastics" },
                    { term: "sly" },
                    { term: "tattoo" },
                    { term: "child combatant" },
                    { term: "ghost" },
                    { term: "bacteria" },
                    { term: "robotic arm" }
                ],
                term: "bacteria",
                icons: [
                    {
                        icon_id: "614322",
                        sprite: "#np_bacteria_614322_000000.svg"
                    },
                    {
                        icon_id: "576052",
                        sprite: "#np_bacteria-beaker_576052_000000.svg"
                    },
                    {
                        icon_id: "260808",
                        sprite: "#np_bacteria-magnification_260808_000000.svg"
                    },
                    {
                        icon_id: "8237",
                        sprite: "#np_germ_8237_000000.svg"
                    },
                    {
                        icon_id: "979685",
                        sprite: "#np_microbe_979685_000000.svg"
                    },
                    {
                        icon_id: "24323",
                        sprite: "#np_worm_24323_000000.svg"
                    }
                ]
            },
            {
                extra_terms: [
                    { term: "ghost" },
                    { term: "bacteria" },
                    { term: "robotic arm" },
                    { term: "gold fish" },
                    { term: "user experience" },
                    { term: "tummy ache" },
                    { term: "lantern" },
                    { term: "pasta roll" },
                    { term: "language" },
                    { term: "vegetable soup" }
                ],
                term: "language",
                icons: [
                    {
                        icon_id: "164140",
                        sprite: "#np_conversation_164140_000000.svg"
                    },
                    {
                        icon_id: "944991",
                        sprite: "#np_language_944991_000000.svg"
                    },
                    {
                        icon_id: "143961",
                        sprite: "#np_online-translator_143961_000000.svg"
                    },
                    {
                        icon_id: "653159",
                        sprite: "#np_sign-language-p_653159_000000.svg"
                    },
                    {
                        icon_id: "987",
                        sprite: "#np_translation_987_000000.svg"
                    },
                    {
                        icon_id: "33974",
                        sprite: "#np_translation_33974_000000.svg"
                    }
                ]
            },
            {
                extra_terms: [
                    { term: "pasta roll" },
                    { term: "language" },
                    { term: "vegetable soup" },
                    { term: "cloud computing" },
                    { term: "keeper glove" },
                    { term: "drug container" },
                    { term: "feeling strong" },
                    { term: "health statistic" },
                    { term: "family" },
                    { term: "wink" }
                ],
                term: "family",
                icons: [
                    {
                        icon_id: "711550",
                        sprite: "#np_family_711550_000000.svg"
                    },
                    {
                        icon_id: "770881",
                        sprite: "#np_family_770881_000000.svg"
                    },
                    {
                        icon_id: "851651",
                        sprite: "#np_family_851651_000000.svg"
                    },
                    {
                        icon_id: "956212",
                        sprite: "#np_family_956212_000000.svg"
                    },
                    {
                        icon_id: "202125",
                        sprite: "#np_lesbian-couple_202125_000000.svg"
                    },
                    {
                        icon_id: "128706",
                        sprite: "#np_mother_128706_000000.svg"
                    }
                ]
            },
            {
                extra_terms: [
                    { term: "health statistic" },
                    { term: "family" },
                    { term: "wink" },
                    { term: "home repairs" },
                    { term: "equalizer" },
                    { term: "happiness" },
                    { term: "successful partnership" },
                    { term: "noodle" },
                    { term: "geometry" },
                    { term: "dance" }
                ],
                term: "geometry",
                icons: [
                    {
                        icon_id: "936786",
                        sprite: "#np_bird_936786_000000.svg"
                    },
                    {
                        icon_id: "879381",
                        sprite:
                            "#np_descriptive-geometry-model_879381_000000.svg"
                    },
                    {
                        icon_id: "11502",
                        sprite: "#np_optical-illusion_11502_000000.svg"
                    },
                    {
                        icon_id: "961231",
                        sprite: "#np_pattern_961231_000000.svg"
                    },
                    {
                        icon_id: "647481",
                        sprite: "#np_sphere_647481_000000.svg"
                    },
                    {
                        icon_id: "945802",
                        sprite: "#np_sphere_945802_000000.svg"
                    }
                ]
            }
        ]
    };
    static propTypes = {
        diverseTermList: React.PropTypes.array.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        };
    }

    moveToNextTerm() {
        let nextTerm =
            this.state.activeIndex < this.props.diverseTermList.length - 1
                ? ++this.state.activeIndex
                : 0;
        // Random number:
        // let nextTerm = Math.floor(Math.random() * (this.props.diverseTermList.length - 1)) + 1
        this.setState({
            activeIndex: nextTerm
        });
    }

    tick = () => {
        $(".diversity-custom-block").removeClass("animate");
        this.moveToNextTerm();
    };

    onInView = () => {
        this.tick();
        window.clearInterval(this.interval);
        this.interval = setInterval(this.tick, 5000);
    };

    onOutOfView = () => {
        window.clearInterval(this.interval);
    };

    componentDidUpdate() {
        window.clearTimeout(this.animateTimeout);
        this.animateTimeout = setTimeout(() => {
            $(".diversity-custom-block").addClass("animate");
        }, 300);
    }

    componentWillUnmount() {
        window.clearInterval(this.interval);
        window.clearTimeout(this.animateTimeout);
    }

    renderDiverseList(itteration) {
        let termList = [],
            iconList = [],
            currentTermClasses = ["show-term", "term-list"],
            viewMoreLink;

        let currentList = this.props.diverseTermList[this.state.activeIndex];
        currentList.extra_terms.forEach(extraTerm => {
            let termClass = [];

            if (
                currentList.extra_terms.indexOf(extraTerm) == currentList.term
            ) {
                termClass.push("currentTerm");
            }
            termList.push(
                <li
                    className={termClass.join(" ")}
                    key={currentList.extra_terms.indexOf(extraTerm)}
                >
                    {extraTerm.term}
                </li>
            );
        });

        currentList.icons.forEach((icon, i) => {
            iconList.push(
                <li key={i} className="diversity-icon">
                    <a
                        href={"/term/" + currentList.term + "/" + icon.icon_id}
                        title={currentList.term}
                    >
                        <svg viewBox="0 0 100 100" width="42" height="42">
                            <use x="0" y="0" xlinkHref={icon.sprite} />
                        </svg>
                    </a>
                </li>
            );
        });
        viewMoreLink = (
            <a
                className="text-link view-more-icons"
                href={"/search?q=" + currentList.term}
            >
                View more {currentList.term} icons
            </a>
        );

        return (
            <div>
                <div className="term-list-container">
                    <ul className={currentTermClasses.join(" ")}>{termList}</ul>
                </div>
                <ul className="display-flex margin-t-xxl">{iconList}</ul>
                <div
                    className="margin-t-xl margin-b-l"
                    style={{ textAlign: "right" }}
                >
                    {viewMoreLink}
                </div>
            </div>
        );
    }

    render() {
        let renderDiverseList = this.renderDiverseList(0);

        return (
            <Inview
                className="custom-block diversity-custom-block margin-t-xxl"
                onInView={this.onInView}
                onOutOfView={this.onOutOfView}
            >
                <div className="container row" style={{ background: "none" }}>
                    <div className="col-lg-7 col-md-7 col-sm-6 col-xs-12">
                        <h1 className="font-xxlarge weight-medium">
                            The most diverse collection of icons<br /> ever.
                        </h1>
                        <p className="font-small weight-light">
                            Find new ways to communicate everything from
                            abstract presentation concepts to playful kids’ book
                            illustrations.
                        </p>
                    </div>
                    <div className="diversity-icon-list col-lg-5 col-md-5 col-sm-6 col-xs-12">
                        {renderDiverseList}
                    </div>
                </div>
            </Inview>
        );
    }
}

module.exports = DiversityCustomBlock;
